"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _kebabCase = _interopRequireDefault(require("lodash/kebabCase"));
var _fontawesomeSvgCore = require("@fortawesome/fontawesome-svg-core");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _styles = require("@material-ui/core/styles");
var _clsx = _interopRequireDefault(require("clsx"));
const _excluded = ["iconBase", "iconPrefix", "iconName", "isActive", "color", "activeColor", "highContrastColor", "className"];
const useClasses = (0, _styles.makeStyles)(({
  accessibility: {
    highContrast
  }
}) => ({
  root: {
    [highContrast.mediaQuery('active')]: {
      color: 'WindowText'
    }
  }
}));
const Icon = _ref => {
  let {
      iconBase,
      iconPrefix,
      iconName,
      isActive,
      color,
      className
    } = _ref,
    rest = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  const _classes = useClasses();
  const _className = (0, _clsx.default)(_classes.root, className);
  const fallbackIcon = /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, (0, _extends2.default)({}, rest, {
    className: _className,
    color: color,
    icon: ['far', 'circle']
  }));
  switch (iconBase.toLowerCase()) {
    case 'gears':
      {
        const gearsPrefix = isActive ? iconPrefix.replace(/.$/, 's') : iconPrefix;
        const icon = (0, _fontawesomeSvgCore.findIconDefinition)({
          prefix: gearsPrefix,
          iconName: (0, _kebabCase.default)(iconName)
        });
        if (!icon) return fallbackIcon;
        return /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, (0, _extends2.default)({}, rest, {
          className: _className,
          icon: [gearsPrefix, iconName],
          color: color
        }));
      }
    case 'font awesome':
      {
        if (!iconPrefix || !iconName) return fallbackIcon;
        const faPrefix = isActive ? iconPrefix.replace(/.$/, 's') : iconPrefix;
        return /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, (0, _extends2.default)({}, rest, {
          className: _className,
          icon: [faPrefix, iconName],
          color: color
        }));
      }
    default:
      return fallbackIcon;
  }
};
Icon.propTypes = {
  isActive: _propTypes.default.bool,
  iconBase: _propTypes.default.oneOf(['gears', 'font awesome']),
  iconPrefix: _propTypes.default.oneOf(['far', 'fab', 'fas', 'tcs', 'tcb', 'tcr']),
  iconName: _propTypes.default.string,
  className: _propTypes.default.string
};
Icon.defaultProps = {
  isActive: false,
  iconBase: 'font awesome',
  iconPrefix: 'far',
  iconName: '',
  className: ''
};
var _default = exports.default = Icon;